"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isoCountryCodeMap = exports.countryCodeIsoMap = exports.THLegacyCountryCode = exports.TIsoCountryCode2Char = exports.UPPER_CASE_COUNTRY_NAME_TO_ISO2_MAPPING = exports.storeCountryToCurrencyCodeMap = void 0;
exports.isIsoCountryCode2Char = isIsoCountryCode2Char;
const mapping_1 = require("../../utils/mapping");
const generated_1 = require("./generated");
/**
 * Map country to ISO numeric. Allowed inputs:
 * - Country name (title case)
 * - Country name (upper case)
 * - Country name (lower case)
 * - ISO2 (lower case)
 * - ISO2 (upper case)
 * - ISO3 (lower case)
 * - ISO3 (upper case)
 *
 * Meant to handle different input shapes since input comes from sanity
 */
exports.storeCountryToCurrencyCodeMap = {
    /**
     * "Great Britain" will probably not be auto generated, since "United Kingdom"
     * is the standard name
     */
    'Great Britain': 826,
    'great britain': 826,
    ...generated_1.storeCountryToCurrencyCodeMapGenerated,
};
/**
 * Maps an upper case country name to the 2-char ISO Code
 */
exports.UPPER_CASE_COUNTRY_NAME_TO_ISO2_MAPPING = {
    ...generated_1.UPPER_CASE_COUNTRY_NAME_TO_ISO2_MAPPING_GENERATED,
    ['GREAT BRITAIN']: generated_1.IsoCountryCode2Char.GB,
};
exports.TIsoCountryCode2Char = new mapping_1.Enum(generated_1.IsoCountryCode2Char);
function isIsoCountryCode2Char(val) {
    try {
        (0, mapping_1.cast)(val, exports.TIsoCountryCode2Char);
    }
    catch (err) {
        return false;
    }
    return true;
}
var THLegacyCountryCode;
(function (THLegacyCountryCode) {
    THLegacyCountryCode["CAN"] = "CA";
    THLegacyCountryCode["USA"] = "US";
})(THLegacyCountryCode || (exports.THLegacyCountryCode = THLegacyCountryCode = {}));
// provide a reverse-lookup of the same
exports.countryCodeIsoMap = new Map(Object.entries(THLegacyCountryCode).map(([key, value]) => [
    value,
    generated_1.IsoCountryCode[key],
]));
// provide a conversion table between ISO country code values and Tim Hortons
exports.isoCountryCodeMap = new Map(Object.entries(generated_1.IsoCountryCode).map(([key, value]) => [
    value,
    THLegacyCountryCode[key],
]));
//# sourceMappingURL=utils.js.map